import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { auth } from 'firebase/app';
import { Router } from '@angular/router';
import { OauthService } from '../service/oauth.service';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(public afAuth: AngularFireAuth, private router: Router, private authService: OauthService, private app: AppComponent) { }

  ngOnInit() {
    this.app.sidenav.close();
  }

  onLoginGoogle(): void{
    this.authService.loginGoogleUser()
    .then( (res) => {
      this.router.navigate(['/home']);
      window.location.reload();
    }).catch(err => console.log('error', err.message))
  }

  onLoginMail(): void{
    let mail = (<HTMLInputElement> document.getElementById('mail')).value;
    let pass = (<HTMLInputElement> document.getElementById('pass')).value;
    this.authService.loginMailUser(mail, pass)
    .then((res) => {
      this.router.navigate(['/home']);
      window.location.reload();
    }).catch(err => console.log('error', err.message))
  }

  onLogout(){
    this.authService.logoutUser();
  }

}
